import styled from 'styled-components';
import { Link } from 'ui/links';
import { TableCell } from 'ui/tableCell';
import { colors } from 'ui/theme';

export const StyledTableCell = styled(TableCell)`
vertical-align: middle;
`;

export const TableLink = styled(Link)`
color: ${colors.textPrimary};
text-decoration: none;
`;
